<template>
	<div class="loading-screen">
		<div class="page-container">
			<img class="loading__spinner" src="@/assets/img/loading.gif" />
		</div>
	</div>
</template>

<script>

export default {
  name: 'LoadingScreen',
	components: {
	},
  data () {
    return {
    }
  },
	created: function () {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".loading-screen";
	#{$c}
	{
		@include extend(absolute-fill);
		position: fixed;
		z-index: 2000;
		background-color: rgba(255,255,255,0.8);
		@include extend(vertical-center);
		text-align: center;
		padding: { top: rem(50); bottom: rem(50); }
	}
</style>



// WEBPACK FOOTER //
// src/components/organisms/LoadingScreen.vue